import React, { useState, useEffect } from 'react';
import { Form, Table, Icon } from 'semantic-ui-react';
import * as _ from 'lodash';
import ApiService from '../../../service/apiService';

import CustomDropdown from '../../common/CustomDropdown';
import * as UtilityFunctions from '../../../HelperMethods/UtilityFunctions';

let debouncedFn = null;

const PreferredLocationComponent = ({ preferedLocationTypePicklist, formik, ...rest }) => {
  const { selectedAsset, givenLocationOptionDict } = rest;
  const preferredLocationFormval = _.cloneDeep(_.get(formik, 'values.preferred_location')) || [
    { locationType: '', location: '' },
  ];
  const [locationOptions, handleLocationOptions] = useState({});

  useEffect(() => {
    const locOptions = {};
    preferredLocationFormval.forEach((val) => {
      const reqAsset = _.get(givenLocationOptionDict, `${val.location}`);
      if (reqAsset) {
        locOptions[val.locationType] = {
          items: [{ key: reqAsset.id, value: reqAsset.id, text: reqAsset.name }],
          isLoading: false,
        };
      }
    });
    handleLocationOptions(locOptions);
  }, [givenLocationOptionDict]);

  const onSearchLocation = (event, locationType) => {
    if (_.size(_.get(event, 'target.value', '')) > 2) {
      if (!debouncedFn) {
        debouncedFn = _.debounce(async (val, fieldId, locType, handleLocOptions) => {
          try {
            handleLocationOptions((prevState) => ({
              ...prevState,
              [locType]: { items: [], isLoading: true },
            }));
            // const reqAreaIds = areas.filter((area) => !area.isDeleted).map((area) => area.areaId);
            const res = await ApiService.getAssetsByAreaIdsAndSearchString({
              fieldId,
              // areaIds: reqAreaIds,
              searchString: val,
            });
            let assets = UtilityFunctions.inflateResponse(res);
            assets = (assets || []).filter((asset) => !asset.isDeleted);
            handleLocOptions((prevState) => ({
              ...prevState,
              [locType]: {
                items: assets.map((asset) => {
                  return { key: asset.id, value: asset.id, text: asset.name };
                }),
                isLoading: false,
              },
            }));
          } catch (error) {
            console.error(error);
          }
        }, 500);
      }
      debouncedFn(_.get(event, 'target.value', ''), selectedAsset.fieldId, locationType, handleLocationOptions);
    }
  };

  const handleFieldChange = (data, index) => {
    const preferLocation = _.cloneDeep(_.get(formik, 'values.preferred_location')) || [
      { locationType: '', location: '' },
    ];
    const field = data.name;
    const { value } = data;
    if (field === 'locationType') {
      preferLocation[index] = { locationType: value, location: '' };
      handleLocationOptions((prevState) => ({
        ...prevState,
        [value]: _.get(locationOptions, `[${value}]`)
          ? { ..._.get(locationOptions, `[${value}]`), isLoading: false }
          : { items: [], isLoading: false },
      }));
    } else if (field === 'location') {
      preferLocation[index] = { ...preferLocation[index], [field]: value };
    }
    const reqPrefLoc = preferLocation[index];
    if (index + 1 === preferLocation.length && reqPrefLoc.locationType && reqPrefLoc.location) {
      preferLocation.push({ locationType: '', location: '' });
    }
    formik.setFieldValue('preferred_location', preferLocation, false);
  };

  const handleDeleteRow = (index) => {
    const preferLocation = _.cloneDeep(formik.values.preferred_location);
    const errorClone = _.cloneDeep(formik.errors.preferred_location);
    if (errorClone) {
      errorClone.splice(index, 1);
      formik.setFieldError('preferred_location', errorClone);
    }
    const reqData = preferLocation[index];
    preferLocation.splice(index, 1);
    const cloneLocationOptions = _.cloneDeep(locationOptions);
    delete cloneLocationOptions[reqData.locationType];
    handleLocationOptions(cloneLocationOptions);
    formik.setFieldValue('preferred_location', preferLocation, false);
  };

  const getOptions = (index, selectedOptVal) => {
    const optionlist = preferedLocationTypePicklist.options || [];
    const selectedOptionIds = preferredLocationFormval.map((val) => val.locationType).filter((val) => val);
    const options = optionlist.filter((item) => {
      if (item.value === selectedOptVal) {
        return true;
      }
      if (selectedOptionIds.includes(item.value)) {
        return false;
      }
      return true;
    });
    return options;
  };

  return (
    <>
      <Table id="partsTable">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>S No</Table.HeaderCell>
            <Table.HeaderCell>Preferred Location Type</Table.HeaderCell>
            <Table.HeaderCell>Location</Table.HeaderCell>
            <Table.HeaderCell>&nbsp;</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        {preferredLocationFormval.map((val, index) => (
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <Form.Field>
                  <label>{index + 1}</label>
                </Form.Field>
              </Table.Cell>
              <Table.Cell>
                <Form.Field style={{ height: '50px' }}>
                  <CustomDropdown
                    placeholder="Choose Location Type"
                    search
                    selection
                    options={getOptions(index, val.locationType)}
                    value={val.locationType}
                    onChange={(e, data) => {
                      handleFieldChange(data, index);
                    }}
                    name="locationType"
                  />
                  {_.get(formik, `errors.preferred_location[${index}].locationType`) && (
                    <div className="errorText">
                      *{_.get(formik, `errors.preferred_location[${index}].locationType`)}
                    </div>
                  )}
                </Form.Field>
              </Table.Cell>
              <Table.Cell>
                <Form.Field style={{ height: '50px' }}>
                  <CustomDropdown
                    placeholder="Choose Location"
                    search
                    selection
                    name="location"
                    value={val.location}
                    options={_.get(locationOptions, `[${val.locationType}]`)}
                    onChange={(e, data) => {
                      handleFieldChange(data, index);
                    }}
                    onSearchChange={(e) => onSearchLocation(e, val.locationType)}
                    disabled={!val.locationType}
                  />
                  {_.get(formik, `errors.preferred_location[${index}].location`) && (
                    <div className="errorText">*{_.get(formik, `errors.preferred_location[${index}].location`)}</div>
                  )}
                </Form.Field>
              </Table.Cell>
              <Table.Cell>
                <Form.Field>
                  {index + 1 !== _.get(formik, 'values.preferred_location', []).length ? (
                    <div onClick={() => handleDeleteRow(index)} className="p-cursor">
                      <Icon name="trash alternate outline" />
                    </div>
                  ) : (
                    <div>
                      <Icon name="trash alternate outline" disabled />
                    </div>
                  )}
                </Form.Field>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        ))}
      </Table>
    </>
  );
};

export default PreferredLocationComponent;
